export default __webpack_public_path__ + "static/media/Group 3380.19b17fa5.png";